<template>
  <div id="area_select">
    <el-select
      v-model="lv1"
      filterable
      allow-create
      size="small"
      style="width: 50%"
      placeholder="请选择"
    >
      <el-option
        v-for="(item, index) in data"
        :key="item.id"
        :value="item.name"
      ></el-option>
    </el-select>
    <el-select
      v-model="lv2"
      filterable
      allow-create
      size="small"
      style="width: 50%"
      placeholder="请选择"
      v-if="!(level1 == null)"
    >
      <el-option
        v-for="(item, index) in option"
        :key="item.id"
        :value="item.name"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      option: {},
    };
  },
  props: {
    data: {
      default: {},
      value: Object,
    },
    level1: {
      default: null,
      value: String,
    },
    level2: {
      default: null,
      value: String,
    },
  },
  watch: {
    lv1(index) {
      let option = this.data.find((v) => {
        if (index == v.name) {
          return true;
        }
      });
      if (option) {
        this.option = option.children;
      } else {
        this.option = [];
      }
    },
  },
  computed: {
    lv1: {
      set(v) {
        this.$emit("update:level2", null);
        this.$emit("update:level1", v);
      },
      get() {
        return this.level1;
      },
    },
    lv2: {
      set(v) {
        this.$emit("update:level2", v);
      },
      get() {
        return this.level2;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#area_select {
  display: flex;
  width: 100%;
}
</style>